import { ClaimStatusTypes } from './ClaimStatus.model'
import { Review } from './Review.model'

export type Agency = {
  id: number
  name: string
  imageURL: string | null
  permalink: string
  address: string | null
  website: string | null
  phone: string | null
  email: string | null
  facebook: string | null
  externalId: string | null
  averageRating: number
  reviewCount: number
  updatedAt: string
  createdAt: string
  reviews?: Review[]
  claimStatus?: ClaimStatusTypes
  submissionNotes?: string | null
  submittedByEmail?: string | null
}

// we offer this to enable the enumerate the Agency type's fields in js/ts files
export const agencyFields: (keyof Agency)[] = [
  'id',
  'name',
  'imageURL',
  'permalink',
  'address',
  'website',
  'phone',
  'email',
  'facebook',
  'externalId',
  'averageRating',
  'reviewCount',
  'updatedAt',
  'createdAt',
  'submissionNotes',
  'submittedByEmail',
]
